export const routeName = 'transparency';
export const slugs: Record<string, string> = {
	en: 'transparency',
	es: 'transparencia',
	ca: 'transparencia',
	it: 'trasparenza',
};
export const sitemap = { changefreq: 'monthly', priority: '0.7', lastmod: '2025-01-01' };
